import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { hapticsImpactLight } from '../../common/haptic';
import { openModal } from '../../redux/slices/modals';
import { ParagraphMediumText } from '../Texts';
import { useTheme } from 'styled-components';
import InfoIcon from '../../assets/icons/info.svg?react';

const CashbackInfo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
      }}
      onClick={() => {
        hapticsImpactLight();
        dispatch(openModal({ name: 'cashback' }));
      }}
    >
      <ParagraphMediumText style={{ color: theme.text.title }}>
        {t('home.earnCashbackWithPurchase')}{' '}
      </ParagraphMediumText>
      <InfoIcon width={18} height={18} color={theme.text.title} />
    </div>
  );
};

export default CashbackInfo;
